import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Versions, Version } from '../../models';
import { IVersionsRepo } from '../interfaces/iversions.repo';
import { UrlPath } from '../../services/UrlPath';

@Injectable()
export class VersionsRepo extends IVersionsRepo {
	private static _versions: Versions;
	private _deferred: Promise<Versions>;

	constructor(
		private urlPath: UrlPath,
		private http: HttpClient
	) {
		super();
	}

	loadVersions(): Promise<Versions> {
		if (!this._deferred) {
			this._deferred = new Promise<Versions>((resolve, reject) => {
				if (VersionsRepo._versions) {
					resolve(VersionsRepo._versions);
					return;
				}

				const appUIPath: string = this.urlPath.getRootPath('assets/version.json');
				const appVersionPromise = new Promise<Version>((aResolve) => {
					this.http.get<any>(appUIPath).subscribe({
						next: (responseData) => {
							const v = new Version(responseData?.version ?? '');
							v.version = responseData?.version ?? '';
							aResolve(v);
						},
						error: () => {
							aResolve(new Version(''));
						},
					});
				});

				Promise.all([appVersionPromise]).then(
					(versions: Version[]) => {
						this._deferred = null;
						VersionsRepo._versions = new Versions(versions[0]);
						resolve(VersionsRepo._versions);
					},
					() => {
						this._deferred = null;
						reject('error loading versions');
					}
				);
			});
		}
		return this._deferred;
	}
}
